import moment from 'moment';
import momentDurationFormat from 'moment-duration-format';

// @ts-ignore
momentDurationFormat(moment);

export default class DateTimeService {
	public static timeFormat = 'HH:mm';

	public static isValidTime(localtime: string) {
		const m = moment(localtime, this.timeFormat, true);
		return m.isValid();
	}

	public static getMinutes(date?: string) {
		if (date) {
			const midnight = moment('00:00', 'HH:mm', true);
			const momentDate = moment(date, 'HH:mm', true);
			const difference = moment.duration(momentDate.diff(midnight));
			const result = difference.as('minutes');
			// if "24:00" entered, treat it as "00:00"
			if (result === 1440) {
				return 0;
			}
			return result;
		}
		return undefined;
	}

	public static minutesToTime(minutes?: number) {
		if (minutes !== undefined && minutes !== null) {
			return moment.utc(moment.duration({ minutes }).asMilliseconds()).format('HH:mm');
		}
	}
}
